import { arrayOf, number, oneOf, oneOfType, shape, string } from "prop-types"

import { linearLocation } from "../linearLocation"

export const technique = shape({
    acronym: string.isRequired,
    code: string.isRequired,
    cost: oneOfType([string, number]).isRequired,
    impact: oneOf([10, 20, 30, 40]).isRequired,
    linearLocation: arrayOf((linearLocation)),
})

export const techniqueForm = shape({
    acronym: string,
    code: string,
    cost: string,
    impact: oneOf([10, 20, 30, 40]),
    linearLocation: linearLocation,
})
